import { BaseService } from "./baseService";
class TimeBreakService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "timebreak";
    }
}
export const timeBreakService = new TimeBreakService();
//# sourceMappingURL=timeBreakService.js.map